import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';
import type { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import type { IDataFrame, ISelectorState } from '@/pages/dashboard/types/dashboard';
import { MOBILE_WEEKLY_PAGE_CONFIG } from './pageConfig/weekly/mobilePageConfig';
import { CASUAL_PAGE_CONFIG } from './pageConfig/weekly/casualPageConfig';
import { PC_PAGE_CONFIG } from './pageConfig/weekly/pcPageConfig';

const reqParams = '/overview/weekly';
const Weekly = () => {
  const dataFrame = useSelector(
    (state: ISelectorState) => state?.dashboard?.currentGame?.data_frame || 'mobile',
    shallowEqual,
  );

  const pageMap = {
    mobile: MOBILE_WEEKLY_PAGE_CONFIG,
    pc: PC_PAGE_CONFIG,
    casual: CASUAL_PAGE_CONFIG,
  };

  return (
    <>
      <CommonPageRender
        reqParams={reqParams}
        pageConfigInit={pageMap?.[dataFrame as IDataFrame] as IPageConfigType}
      />
    </>
  );
};

export default Weekly;
